export const niveis = [
  { value: 1, label: 'Novato', cor: '255, 89, 89' },
  { value: 2, label: 'Iniciante', cor: '255, 145, 89' },
  { value: 3, label: 'Habilidoso', cor: '243, 183, 33' },
  { value: 4, label: 'Experiente', cor: '128, 204, 20' },
  { value: 5, label: 'Especialista', cor: '37, 184, 105' },
];
